import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_tradie-calc/artifacts/7gao9ygf_NXTAXLOGOW.2022.png";

/**
 * NZ Taxation Ltd brand mark.
 * variant="full"  -> logo + wordmark
 * variant="mark"  -> logo only (use on tight spaces / mobile topbars)
 * size: "sm" | "md" | "lg"
 */
export default function Brand({ variant = "full", size = "md", className = "" }) {
  const dims = {
    sm: { box: "h-9 w-9 p-1", title: "text-sm", sub: "text-[10px]" },
    md: { box: "h-11 w-11 p-1", title: "text-lg", sub: "text-xs" },
    lg: { box: "h-16 w-16 p-1.5", title: "text-2xl", sub: "text-xs" },
  }[size];

  return (
    <div className={`flex items-center gap-3 min-w-0 ${className}`}>
      <div className={`${dims.box} bg-white flex items-center justify-center shrink-0`}>
        <img
          src={LOGO_URL}
          alt="NZ Taxation Ltd"
          className="w-full h-full object-contain"
          data-testid="brand-logo"
        />
      </div>
      {variant === "full" && (
        <div className="leading-none min-w-0">
          <div
            className={`font-display ${dims.title} tracking-tight whitespace-nowrap`}
          >
            NZ TAXATION <span className="text-[var(--primary)]">LTD</span>
          </div>
          <div
            className={`label-mono mt-1 ${dims.sub} whitespace-nowrap`}
          >
            TRADIE CALCULATOR
          </div>
        </div>
      )}
    </div>
  );
}
